module.exports = __webpack_public_path__ + "static/media/authentication-bg.4221b632.jpg";